module.exports = __webpack_public_path__ + "img/message-add.6af9719a.svg";